import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OSUpdatesService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { AvailableOsUpdatesResolverActions, OsUpdatesApiActions } from './available-os-updates.actions';

@Injectable()
export class AvailableOsUpdatesEffects {
  private readonly actions = inject(Actions);
  private readonly osUpdatesService = inject(OSUpdatesService);

  AvailableOsUpdatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(AvailableOsUpdatesResolverActions.availableOsUpdatesRequested),
      mergeMap(() =>
        safeMap(
          this.osUpdatesService.getOSUpdates({ apiVersion: '2.0' }),
          (availableOsUpdates) =>
            OsUpdatesApiActions.availableOsUpdatesLoaded({
              availableOsUpdates,
            }),
          (error) => OsUpdatesApiActions.availableOsUpdatesLoadedError({ error })
        )
      )
    );
  });
}
